export default __webpack_public_path__ + "static/media/house-guard.269a35c2.svg";